/**
 * Converts string timestamp to a value compatible with Protocol Buffer int64/bigint
 * Returns number with bigint type assertion to avoid JSON serialization errors
 *
 * Note: Unix timestamp in milliseconds fits within Number.MAX_SAFE_INTEGER,
 * so no precision is lost
 */
export const parseTimestampForProtobuf = (timestamp: string): bigint => {
  return Number(timestamp) as unknown as bigint;
};
